import type { ISerialize } from '@/objects/ISerialize';

export class PostResponse implements ISerialize {
    public IDS: number[];

    public Success: boolean;

    public TranslationKey: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { IDS?: number[]; Success?: boolean; TranslationKey?: string | null }) {
        this.IDS = values.IDS ?? [];

        this.Success = values.Success ?? false;

        this.TranslationKey = values.TranslationKey ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"IDS": [ ${this.IDS.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"Success": ${JSON.stringify(this.Success)}` +
            ',' +
            `"TranslationKey": ${JSON.stringify(this.TranslationKey)}` +
            '}'
        );
    }

    /**
     * Creates an instance of PostResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { IDS?: number[]; Success?: boolean; TranslationKey?: string | null }): PostResponse {
        return new PostResponse(values);
    }

    public static _FromServerJson(json: any): PostResponse {
        return new PostResponse({ IDS: json.IDS, Success: json.Success, TranslationKey: json.TranslationKey ?? '' });
    }

    /**
     * Creates an instance of PostResponse from another instance of PostResponse.
     * @param other The PostResponse you want to clone
     * @returns A cloned PostResponse
     */
    public static FromOther(other: PostResponse): PostResponse {
        return PostResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return PostResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'PostResponse';
}
